import classNames from 'classnames'
import type { FacetValue } from 'src/components/search/FilterV2/types'

type FilterButtonProps = {
  facetKey: string
  facetValue: FacetValue | undefined
  onClick: (facetValue: FacetValue) => void
  label: string
  Icon?: React.ComponentType<{ color: string }>
}

const QuickFilterButtonV3 = ({
  facetKey,
  facetValue,
  onClick,
  label,
  Icon,
}: FilterButtonProps) => {
  if (!facetValue) {
    return null
  }

  const { selected } = facetValue

  return (
    <button
      onClick={() => onClick(facetValue)}
      data-testId={`desktop-${facetKey}`}
      className={classNames(
        'flex h-[46px] gap-2 py-3 px-4 items-center justify-center border rounded-round shrink-0 min-w-fit',
        selected
          ? 'bg-restructure-background-neutral-12 border-restructure-background-neutral-12'
          : 'border-restructure-background-neutral-5'
      )}
    >
      {Icon && <Icon color={selected ? '#3643BA' : '#101010'} />}
      <p
        className={classNames(
          'font-medium text-sm font-inter text-nowrap',
          selected ? 'text-white' : 'text-restructure-primary'
        )}
      >
        {label}
      </p>
    </button>
  )
}

export default QuickFilterButtonV3
